// src/utils/sessionStorage.ts

import { REFRESH_TOKEN_KEY, SESSION_TOKEN_KEY } from "@/constants";

export function setSessionToken(token: string): void {
  localStorage.setItem(SESSION_TOKEN_KEY, token);
}

export function getSessionToken(): string | null {
  return localStorage.getItem(SESSION_TOKEN_KEY);
}

export function clearSessionToken(storage: Storage = localStorage): void {
  storage.removeItem(SESSION_TOKEN_KEY);
}

export function setUkekInStorage(userId: string, ukek: string): void {
  localStorage.setItem(`${userId}-ukek`, ukek);
}

export function getUkekFromStorage(userId: string): string | null {
  return localStorage.getItem(`${userId}-ukek`);
}

export function clearUkekFromStorage(userId: string): void {
  localStorage.removeItem(`${userId}-ukek`);
}

export function getRefreshToken(): string | null {
  return localStorage.getItem(REFRESH_TOKEN_KEY);
}

export function setRefreshToken(token: string): void {
  localStorage.setItem(REFRESH_TOKEN_KEY, token);
}

export function clearRefreshToken(): void {
  localStorage.removeItem(REFRESH_TOKEN_KEY);
}

export function clearAuthTokens(): void {
  clearSessionToken();
  clearRefreshToken();
}
